import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

const LABELS = { free: "Starter", pro: "Pro", founder: "Fondatore", beta: "Beta Tester" };

export function PlanBadge({ plan, founder }) {
  if (!plan) return null;
  const isPaid = plan === "pro" || plan === "founder" || plan === "beta";
  return (
    <span
      data-testid="plan-badge"
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold border ${
        plan === "founder"
          ? "bg-amber-50 text-amber-700 border-amber-200"
          : plan === "pro"
          ? "bg-indigo-50 text-indigo-700 border-indigo-200"
          : "bg-slate-100 text-slate-500 border-slate-200"
      }`}
    >
      {isPaid ? <Crown style={{ width: 12, height: 12 }} /> : <Sparkles style={{ width: 12, height: 12 }} />}
      {LABELS[plan] || plan}
      {founder && plan === "founder" ? " 🏅" : ""}
    </span>
  );
}

export function ProLock({ label = "PRO", onClick, testid }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-700 border border-amber-200 px-2 py-0.5 text-[10px] font-bold hover:bg-amber-200 transition-colors"
    >
      <Lock style={{ width: 11, height: 11 }} /> {label}
    </button>
  );
}

export function UpgradeDialog({ open, onOpenChange, feature }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="pro-upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Crown style={{ width: 18, height: 18 }} className="text-primary" /> Funzione Pro
          </DialogTitle>
          <DialogDescription>
            {feature ? `"${feature}" è disponibile nei piani Pro e Fondatore.` : "Questa funzione è disponibile nei piani Pro e Fondatore."} Sblocca tutte le funzionalità avanzate, preventivi illimitati e white-label.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Più tardi</Button>
          <Button data-testid="pro-upgrade-cta" onClick={() => navigate("/billing")} className="font-semibold">
            <Crown style={{ width: 16, height: 16 }} className="mr-2" /> Scopri i piani Pro
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
